var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Back_button",
    "data-name": "Back button",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Frame",
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Chevron",
    d: "M1.332-10.1a.97.97,0,0,0,.077.389,1.1,1.1,0,0,0,.239.34L7.954-3.2a.9.9,0,0,0,.664.275A.936.936,0,0,0,9.1-3.051a.966.966,0,0,0,.344-.34.9.9,0,0,0,.13-.474.946.946,0,0,0-.3-.688L3.591-10.1l5.683-5.545a.938.938,0,0,0,.3-.68.893.893,0,0,0-.13-.478.977.977,0,0,0-.344-.336.936.936,0,0,0-.482-.125A.919.919,0,0,0,7.954-17L1.648-10.827a1.1,1.1,0,0,0-.239.34A.97.97,0,0,0,1.332-10.1Z",
    transform: "translate(6.547 22.094)",
    fill: "#da291c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBack);
export default __webpack_public_path__ + "static/media/icon_back.034f5255234dcf93598b014e3118312b.svg";
export { ForwardRef as ReactComponent };